export default __webpack_public_path__ + "static/media/ct4.2.fb952ede.png";